module.exports = __webpack_public_path__ + "static/media/play_preview.a784af50.svg";